// extracted by mini-css-extract-plugin
module.exports = {"rowWrapper":"styles_rowWrapper__3Emlv","logoWrapper":"styles_logoWrapper__1uNjm"};